import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import BookDetailsContainer from "./BookDetailsContainer";
import BookResourcesContainer from "./BookResourcesContainer";
import BookCoursewareContainer from "./BookCoursewareContainer";
import { Tab, Tabs, TabList, TabPanel } from "../../../../../components/tabs";
import { Translation } from "../../../../../core/translate";
import { selectors as routerSelectors } from "../../../../../../redux/router";
import { selectors as feenySelectors } from "../../../../../../redux/feeny";
import { selectors as ancillarySelectors } from "../../../../../../redux/ancillaries";
import { OffScreenStyles } from "../../../../../components/mixins";
import { withAllMatches } from "../../../../../components/mediaquery/breakpoints";
import {
  selectors as uiLibrarySelectors,
  actions as uiLibraryActions
} from "../../../../../../redux/ui/library";

const WrapperOuter = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const TabBar = styled(Tabs)`
  padding-top: 15px;
  height: 100%;
  position: relative;
`;

const defaultTabs = {
  listStyle: "none",
  display: "flex",
  justifyContent: "normal",
  margin: "0",
  width: "100%",
  whiteSpace: "nowrap",
  overflowX: "auto"
};

const TabBarText = styled(Tab)`
  flex: 1;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  display: flex;
  font-size: 1.6rem;
  font-weight: 500;
  color: ${cloud.getShade(10)};
  border-right: ${cloud.getShade(4)} solid 1px;
  position: relative;
  height: 35px;
  min-width: 30%;
  &:last-child {
    border: none;
  }
  span {
    span {
      padding: 0 10px 5px;
    }
  }
  &.react-tabs__tab--selected {
    span {
      span {
        border-bottom: solid ${props => props.theme.color.secondary.getShade(6)}
          4px;
      }
    }
  }
`;

const TabPanelContainer = styled.div`
  position: absolute;
  top: 55px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
`;

const TabPanelInner = styled(TabPanel)`
  &.react-tabs__tab-panel--selected {
    height: 100%;
  }
`;

const CopyURLHeader = styled.h3`
  margin: 25px 0 10px 0;
`;

const CitationHeader = styled(CopyURLHeader)``;

const ArchiveHeader = styled(CopyURLHeader)``;

const TabsContainer = ({
  isbn,
  ancillarySummary,
  panel,
  changePanelTab,
  accessCode,
  native
}) => {
  const tabs = [
    {
      tabID: "details",
      tabText: <Translation id="library.details">Details</Translation>,
      tabPanel: <BookDetailsContainer isbn={isbn} />
    }
  ];
  if (accessCode && !ancillarySummary.ssoOnly) {
    tabs.push({
      tabID: "courseware",
      tabText: <Translation id="eresources.courseware">Courseware</Translation>,
      tabPanel: <BookCoursewareContainer isbn={isbn} />
    });
  }

  if (ancillarySummary.ancillariesCount > 0 && !native) {
    tabs.push({
      tabID: "resources",
      tabText: <Translation id="filter.resources">Resources</Translation>,
      tabPanel: <BookResourcesContainer isbn={isbn} source="library" />
    });
  }
  const selectedIndex = tabs.findIndex(tab => panel.data.tab === tab.tabID);
  const tabStyles = tabs.length > 1 ? defaultTabs : OffScreenStyles;

  const SingleTab = <BookDetailsContainer isbn={isbn} />;

  const TabsContainer = (
    <TabBar
      selectedIndex={Math.max(0, selectedIndex)}
      onSelect={index => changePanelTab(tabs[index].tabID)}
    >
      <TabList style={tabStyles}>
        {tabs.map(tab => (
          <TabBarText key={`tab-${tab.tabID}`}>{tab.tabText}</TabBarText>
        ))}
      </TabList>
      <TabPanelContainer>
        {tabs.map(tab => (
          <TabPanelInner key={`panel-${tab.tabID}`}>
            {tab.tabPanel}
          </TabPanelInner>
        ))}
      </TabPanelContainer>
    </TabBar>
  );

  return (
    <WrapperOuter>
      {tabs.length <= 1 ? <TabBar>{SingleTab}</TabBar> : TabsContainer}
    </WrapperOuter>
  );
};

const mapStateToProps = (state, props) => ({
  panel: uiLibrarySelectors.getPanel(state),
  ancillarySummary: ancillarySelectors.getAncillarySummaryForVbid(
    state,
    props.isbn
  ),
  accessCode: ancillarySelectors.getAccessCodesForVbid(state, props.isbn),
  native: routerSelectors.isNative(state)
});

const mapDispatchToProps = (dispatch, props) => ({
  changePanelTab: tab => dispatch(uiLibraryActions.changePanelTab(tab))
});

export default withAllMatches(
  withTheme(connect(mapStateToProps, mapDispatchToProps)(TabsContainer))
);
